import React from "react";

const ELDER_GUIDE_VIDEO_URL =
  "https://www.youtube-nocookie.com/embed/FjkneIEx63M?rel=0";

function ElderMarketingPage() {
  return (
    <div className="page-shell">
      <section className="page-panel role-page role-page-elder marketing-page-panel">
        <div className="page-content marketing-page-content">
          <div className="role-hero-layout">
            <div>
              <div className="intro-badge">Elder Home Page</div>
              <h1 className="page-title">
                Support that helps families discover trusted caregivers with clarity and confidence.
              </h1>
              <p className="page-subtitle">
                UberCARE gives elders and families a calmer way to explore care. The platform
                brings caregiver discovery, map-based search, WhatsApp contact, and global
                caregiver visibility into one simple experience designed to feel practical,
                reassuring, and easy to understand.
              </p>

              <section className="role-highlight-card">
                <div className="mini-label">Why families pay attention</div>
                <h3>A marketing page that clearly shows the value before any login is needed.</h3>
                <p>
                  This experience is focused on persuasion and trust. It shows what customers can
                  expect from the product: browsing caregivers on a live care map, narrowing
                  choices with useful filters, and finding registered caregivers from different
                  parts of the world without confusion.
                </p>
              </section>

              <section className="section-block">
                <h2 className="section-title">What customers can expect</h2>
                <div className="journey-list marketing-journey-list">
                  <MarketingPoint
                    title="WhatsApp contact directly from the care map"
                    text="Families can identify a caregiver on the map, view the profile details, and move quickly into a WhatsApp conversation or call when they are ready to reach out."
                  />
                  <MarketingPoint
                    title="Smarter caregiver filtering"
                    text="Customers can narrow results by language, gender, country, and care rate so the search experience feels intentional instead of overwhelming."
                  />
                  <MarketingPoint
                    title="Visibility of caregivers across the world"
                    text="The platform makes it easier to explore registered caregivers beyond one city or one region, helping families think globally when searching for trusted support options."
                  />
                </div>
              </section>
            </div>

            <div className="role-media-stack">
              <section className="hero-card hero-visual media-card role-video-card">
                <div className="media-label">Elder Guide Video</div>
                <iframe
                  className="hero-video elder-video elder-youtube-video"
                  src={ELDER_GUIDE_VIDEO_URL}
                  title="UberCARE elder guide video"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </section>

              <section className="role-summary-card">
                <div className="mini-label">What makes the message stronger</div>
                <h3>Clearer benefits, real care language, and a more persuasive first impression.</h3>
                <p>
                  Instead of asking people to log in immediately, this page gives them room to
                  understand the benefit: easier caregiver discovery, faster communication, and a
                  broader view of who is available to help.
                </p>
              </section>
            </div>
          </div>

          <section className="section-block">
            <h2 className="section-title">A simple customer journey</h2>
            <div className="steps-grid marketing-steps-grid">
              <MarketingStep
                number="1"
                title="See the value immediately"
                text="The page introduces the platform in plain language and explains why it matters for elder care."
              />
              <MarketingStep
                number="2"
                title="Watch the product in context"
                text="The current elder guide video helps people picture the experience and builds familiarity."
              />
              <MarketingStep
                number="3"
                title="Understand the map experience"
                text="Customers learn that caregivers can be discovered, compared, and contacted from the same map flow."
              />
              <MarketingStep
                number="4"
                title="Leave with stronger trust"
                text="The message stays focused on confidence, accessibility, and worldwide caregiver visibility."
              />
            </div>
          </section>

          <section className="marketing-closing-band">
            <h2>UberCARE helps elder care feel more visible, more reachable, and more human.</h2>
            <p>
              This standalone page is designed for marketing conversations, customer demos, and
              persuasion. It presents the elder experience with the current video, the core product
              value, and a cleaner story that keeps the customer focused on benefits instead of
              forms, links, or login actions.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}

function MarketingPoint({ title, text }) {
  return (
    <article className="journey-step">
      <div className="step-number">E</div>
      <div>
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </article>
  );
}

function MarketingStep({ number, title, text }) {
  return (
    <article className="step-card">
      <div className="step-number">{number}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </article>
  );
}

export default ElderMarketingPage;
